<template>
  <div>
    <template v-if="isDiagramView">
      <RoomStatusDiagram />
    </template>
    <template v-else>
      <div class="content-container">
        <search-comp @onSearch="onSearch" @onReset="onResetSearch">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-2">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Ngày' }}
                    </div>
                    <div class="child-w-80">
                      <CalendarSelect
                        v-model="searchParams.date"
                        style="display: block; width: 100%"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-2">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Khách sạn' }}
                    </div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParams.hotelId"
                        clearable
                        @change="selectHotel"
                      >
                        <el-option
                          v-for="(hotel, index) in hotelList"
                          :key="index"
                          :value="hotel.id"
                          :label="hotel.name"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>

                <div class="das-form-col col-2">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Hạng phòng' }}
                    </div>
                    <div class="child-w-80">
                      <el-select v-model="searchParams.roomLevelId" clearable>
                        <el-option
                          v-for="(hotel, index) in roomLevelRows"
                          :key="index"
                          :value="hotel.id"
                          :label="hotel.name"
                        ></el-option>
                      </el-select>
                      <!-- <select-with-search-table
                        style="width: 100%"
                        index-field="id"
                        :search-fields="['id', 'code', 'name']"
                        :selected-index-field-value="searchParams.roomLevelId"
                        :value="searchParams.roomLevelId"
                        :rows="roomLevelRows"
                        :columns="roomLevelCols"
                        :dropdown-width="400"
                        :is-remove-btn="true"
                        @selectionChanged="onSelectRoomLevel"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          <div>
                              {{ selectedData?.name }}
                            </span>
                          </div>
                        </template>
                      </select-with-search-table> -->
                    </div>
                  </div>
                </div>

                <div class="das-form-col col-2">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Trạng thái' }}
                    </div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParams.status"
                        placeholder="Vui lòng chọn"
                      >
                        <el-option
                          v-for="item in statusOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>

                      <!-- <select
                    id="status"
                    v-model="searchParams.status"
                    name="status"
                    placeholder="Chọn"
                  >
                    <option
                      v-for="item in statusOptions"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.label }}
                    </option>
                  </select> -->
                    </div>
                  </div>
                </div>

                <div class="das-form-col col-2">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Phòng' }}
                    </div>
                    <div class="child-w-80">
                      <input v-model="searchParams.roomNum" type="text" />
                    </div>
                  </div>
                </div>

                <div class="das-form-col col-2">
                  <div class="das-form-input">
                    <div class="label">
                      {{ 'Thuộc tính' }}
                    </div>
                    <div class="child-w-80">
                      <select-with-search-table
                        style="width: 100%"
                        index-field="id"
                        :search-fields="['id', 'code', 'name']"
                        :selected-index-field-value="searchParams.property"
                        :value="searchParams.property"
                        :rows="propertyRows"
                        :columns="propertyCols"
                        :dropdown-width="600"
                        :is-remove-btn="true"
                        :multiple="true"
                        @selectionChanged="onSelectProperty"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          <span v-for="data in selectedData" :key="data.code"
                            >{{ data.name }},
                          </span>
                          <!-- {{ selectedData?.name }} {{ selectedData?.code }} -->
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="das-form-row"
                style="
                  vertical-align: middle;
                  background: #f0f0f5;
                  padding: 0 8px;
                  margin: 0;
                  height: 32px;
                  align-items: center;
                  border-radius: 5px;
                "
              >
                <div class="das-form-col col-2">
                  <div class="checkbox-wrap">
                    <input
                      id="isNotOOO"
                      v-model="searchParams.isNotOOO"
                      type="checkbox"
                    />
                    <label
                      for="isNotOOO"
                      style="color: #606266; font-size: 14px"
                      >{{ 'Trừ phòng OOO' }}</label
                    >
                  </div>
                </div>
                <div class="das-form-col col-2">
                  <div class="checkbox-wrap">
                    <input
                      id="isNotCI"
                      v-model="searchParams.isNotCI"
                      type="checkbox"
                    />
                    <label
                      for="isNotCI"
                      style="color: #606266; font-size: 14px"
                      >{{ 'Trừ phòng đã kiểm tra' }}</label
                    >
                  </div>
                </div>
                <div class="das-form-col col-2">
                  <div class="checkbox-wrap">
                    <input
                      id="isNotD"
                      v-model="searchParams.isNotD"
                      type="checkbox"
                    />
                    <label
                      for="isNotD"
                      style="color: #606266; font-size: 14px"
                      >{{ 'Trừ phòng bẩn' }}</label
                    >
                  </div>
                </div>
                <div class="das-form-col col-2">
                  <div class="checkbox-wrap">
                    <input
                      id="isNotC"
                      v-model="searchParams.isNotC"
                      type="checkbox"
                    />
                    <label
                      for="isNotC"
                      style="color: #606266; font-size: 14px"
                      >{{ 'Trừ phòng sạch' }}</label
                    >
                  </div>
                </div>
                <div class="das-form-col col-2">
                  <div class="checkbox-wrap">
                    <input
                      id="isLastDepartDate"
                      v-model="searchParams.isLastDepartDate"
                      type="checkbox"
                    />
                    <label
                      for="isLastDepartDate"
                      style="color: #606266; font-size: 14px"
                      >{{ 'Đến hạn đi' }}</label
                    >
                  </div>
                </div>
                <div class="das-form-col col-2">
                  <div class="checkbox-wrap">
                    <input
                      id="onlyDisplayDiff"
                      v-model="searchParams.onlyDisplayDiff"
                      type="checkbox"
                    />
                    <label
                      for="onlyDisplayDiff"
                      style="color: #606266; font-size: 14px"
                      >{{ 'Chỉ hiện sai lệch' }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>

        <div class="statistic" style="margin-top: -10px">
          <div class="item">
            <div class="number">{{ 0 }}</div>
            <div class="text">{{ 'Tổng số phòng' }}</div>
          </div>
        </div>

        <div v-loading="loading" class="grid-scroll">
          <GridVx
            ref="agGrid"
            :auto-size-cell="true"
            :columns="columns"
            :rows="rows"
            class="agGrid"
            dom-layout="scroll"
          />
        </div>
        <!-- <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div> -->

        <div class="button-containers mb-0">
          <button class="btn primary small" @click="fnGetRoomStatusExcel">
            {{ 'Xuất excel' }}
          </button>
          <!-- <button class="btn primary small outline">
            {{ 'Lịch sử' }}
          </button> -->
          <button class="btn primary small outline">
            {{ 'Chi tiết' }}
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
import paginationMixin from '@/mixins/paginationMixin'
import RoomStatusDiagram from './RoomStatusDiagram.vue'

import { getRoomStatus, getRoomStatusExcel } from '@/api/reception/reception'
import { getAllHotel } from '@/api/hotel'
import { callGetRoomLevel, callGetRoomProperty } from './utils/commonApiCall'
import * as dayjs from 'dayjs'
import _ from 'lodash'

export default {
  components: { CalendarSelect, RoomStatusDiagram, CellRenderCheckboxReadonly },
  mixins: [paginationMixin],
  data() {
    return {
      isDiagramView: this.$route.query.diagram,
      // search box
      searchShow: true,
      hotelList: [],
      // search panel
      searchParams: {
        date: dayjs().format('YYYY-MM-DD'),
        roomLevelId: null,
        status: null,
        roomNum: null,
        property: [],
        isNotOOO: false,
        isNotCI: false,
        isNotD: false,
        isNotC: false,
        isLastDepartDate: false,
        onlyDisplayDiff: false,
        hotelId: null
      },
      defaultSearchParams: {
        date: dayjs().format('YYYY-MM-DD'),
        roomLevelId: null,
        status: null,
        roomNum: null,
        property: [],
        isNotOOO: false,
        isNotCI: false,
        isNotD: false,
        isNotC: false,
        isLastDepartDate: false,
        onlyDisplayDiff: false
      },

      roomLevelRows: [],
      roomLevelCols: [
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      propertyRows: [],
      propertyCols: [
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],

      status: null,
      statusOptions: [
        { label: 'VD', value: '01' },
        { label: 'VC', value: '02' },
        { label: 'VT', value: '03' },
        { label: 'VCI', value: '04' },
        { label: 'OOO', value: '05' },
        { label: 'OOS', value: '06' },
        { label: 'OD', value: '11' },
        { label: 'OC', value: '12' },
        { label: 'OT', value: '13' },
        { label: 'OCI', value: '14' }
      ],

      rows: [],
      loading: false
    }
  },

  computed: {
    columns() {
      return [
        {
          headerName: 'Số phòng',
          field: 'room_num',
          minWidth: 100
        },
        {
          headerName: 'Hạng phòng',
          field: 'room_level_code',
          minWidth: 200
        },
        // {
        //   headerName: 'Trạng thái',
        //   field: 'status'
        // },
        {
          headerName: 'Trạng thái',
          field: 'status_nm',
          minWidth: 100,
          cellStyle: params => {
            const data = params.data.status_nm
            const property = {
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: null
            }
            if (data === 'VCI' || data === 'OCI') {
              // checked
              property.backgroundColor = '#c3edd9'
              property.color = '#357456'
            } else if (data === 'VD' || data === 'OD') {
              // dirty
              property.backgroundColor = '#ffdfe1'
              property.color = '#f12b37'
            } else if (data === 'OOS' || data === 'OOO') {
              property.backgroundColor = '#cdcccc'
              property.color = '#575757'
            } else {
              // clean
              property.backgroundColor = '#ffecd5'
              property.color = '#ea7e00'
            }
            return property
          }
        },
        {
          headerName: 'Ngày đi cuối',
          field: 'last_departure',
          minWidth: 200
        },
        {
          headerName: 'Chặng ở tiếp theo',
          field: 'next_arrive',
          minWidth: 200
        },
        {
          headerName: 'Sai lệch',
          field: 'diff',
          minWidth: 100
        },
        {
          headerName: 'Bị chiếm',
          field: 'not_available',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckboxReadonly',
          minWidth: 80
        },
        {
          headerName: 'Thuộc tính',
          field: 'room_property',
          minWidth: 300
        },
        // {
        //   headerName: 'Tòa nhà',
        //   field: ''
        // },
        // {
        //   headerName: 'Cánh',
        //   field: ''
        // },
        // {
        //   headerName: 'Hướng phòng',
        //   field: ''
        // },
        {
          headerName: 'Mô tả',
          field: 'desc',
          minWidth: 300,
          flex: 1
        }
      ]
    }
  },
  created() {
    this.getListHotel()
  },

  async mounted() {
    this.roomLevelRows = await callGetRoomLevel()
    this.propertyRows = await callGetRoomProperty()
    this.onSearch()
  },

  methods: {
    // handle event
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    onSelectRoomLevel(data) {
      this.searchParams.roomLevelId = data?.id || null
    },
    onSelectProperty(data) {
      this.searchParams.property = data?.map(item => item.id) || null
    },
    async selectHotel(data) {
      this.roomLevelRows = await callGetRoomLevel({
        hotelId: data
      })
      this.searchParams.roomLevelId = null
    },

    // pagination
    // async onPageChanged(pageNum) {
    //   this.pageParams.pageNum = pageNum
    //   await this.fnGetListAgent()
    // },
    // async onPageSizeChange(pageSize) {
    //   this.pageParams.pageSize = pageSize
    //   this.pageParams.pageNum = 1
    //   await this.fnGetListAgent()
    // },

    // btn
    onSearch() {
      this.fnGetRoomStatus()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetRoomStatus()
    },

    // handle api call
    fnGetRoomStatus() {
      this.loading = true
      getRoomStatus(this.searchParams)
        .then(res => {
          if (!res.is_error) {
            this.rows = res.data
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    fnGetRoomStatusExcel() {
      getRoomStatusExcel(this.searchParams)
        .then(res => {
          if (!res?.is_error) {
            const href = URL.createObjectURL(res)
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              `room-status.xlsx`
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()

            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    }
  }
}
</script>
